import {Canvas} from 'fabric/fabric-impl';
import type {Tools} from '../tools/init-tools';
import type {PixpenState} from './store';
import {useStore} from './store';

export function state(): PixpenState {
  return useStore.getState();
}

export function tools(): Tools {
  return state().editor.tools;
}

export function fabricCanvas(): Canvas {
  return state().fabric;
}
